/**
 * @flow
 * @relayHash 4249b16677d22efc49790bb2445d216b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type documentChangesFromPreviousVersionQueryVariables = {|
  documentPk: number
|};
export type documentChangesFromPreviousVersionQueryResponse = {|
  +documentChangesFromPreviousVersion: ?{|
    +taskId: ?string
  |}
|};
export type documentChangesFromPreviousVersionQuery = {|
  variables: documentChangesFromPreviousVersionQueryVariables,
  response: documentChangesFromPreviousVersionQueryResponse,
|};
*/


/*
query documentChangesFromPreviousVersionQuery(
  $documentPk: Int!
) {
  documentChangesFromPreviousVersion(documentId: $documentPk) {
    taskId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "documentPk",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "documentChangesFromPreviousVersion",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentPk",
        "type": "Int!"
      }
    ],
    "concreteType": "DocumentChangesTaskIdType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "taskId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "documentChangesFromPreviousVersionQuery",
  "id": "8c53487e4ace8d8f41b1a50c57c17c93",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "documentChangesFromPreviousVersionQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "documentChangesFromPreviousVersionQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "query documentChangesFromPreviousVersionQuery(\n  $documentPk: Int!\n) {\n  documentChangesFromPreviousVersion(documentId: $documentPk) {\n    taskId\n  }\n}\n";
(node/*: any*/).hash = 'db6ecfc304eae0ad2a9fdd431982054e';
module.exports = node;
